<template>
  <header class="header-wrap">
    <img :src="pcLogoUrl"
      mode="scaleToFill"
      class="header-logo"
      @click="handleToHome" />

    <a class="ship-btn"
      :href="registerUrl"
      target="_blank"
      rel="noopener noreferrer">
      <span class="ship-btn-icon">
        🚚
      </span>
      <span class="ship-btn-text">
        {{ title1 }}
      </span>
    </a>
  </header>
</template>

<script>

export default {
  name: "pageHeader",

  data() {
    return {
      pcLogoUrl: '',
      title1: '',
      registerUrl: '',
    }
  },
  methods: {
    handleToHome() {
      this.$router.push("/home").catch(err => {
        // 捕获重复导航错误，不做处理
      })
    }
  },

  mounted() {
    const homeData = JSON.parse(sessionStorage.getItem('homeData'))

    this.pcLogoUrl = homeData.homeContent.pcImage1
    this.title1 = homeData.homeContent.title1
    const { registerUrl, invitationCode } = homeData.expert.expertPlatformList[0]
    this.registerUrl = registerUrl.replace('{inviteCode}', invitationCode)
  }
}
</script>

<style scoped lang="scss">
.header-wrap {
  width: 100%;
  padding: 16px;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-logo {
    width: 52px;
    height: 52px;
  }

  .ship-btn {
    height: 42px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: linear-gradient(135deg, hsl(from var(--primary-color) h s l / 0.5), var(--primary-color));
    color: #0A0800 !important;
    border: none;
    border-radius: 100px;
    padding: 10px 16px;
    font-family: "DM Sans", sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 0 2px 12px hsl(from var(--primary-color) h s l / 0.35);
    transition: transform .15s, box-shadow .15s;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    overflow: hidden;

    .ship-btn-text {
      width: 120px;
      white-space: normal;
      line-height: 1.35;
    }
  }

  .ship-btn:hover {
    color: #0A0800 !important;
  }
}
</style>